import { render, staticRenderFns } from "./ReferansSelect.vue?vue&type=template&id=6a608baf&scoped=true"
import script from "./ReferansSelect.vue?vue&type=script&lang=ts"
export * from "./ReferansSelect.vue?vue&type=script&lang=ts"
import style0 from "./ReferansSelect.vue?vue&type=style&index=0&id=6a608baf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a608baf",
  null
  
)

export default component.exports